module.exports = __webpack_public_path__ + "static/media/getting-support-large.e0b9b403.png";